<template>
  <form-element
    v-model="transportMethod"
    :required="true"
    :form-element="formElement"
  />
</template>

<script>
import FormElement from "../form/FormElement"
import { getTransportMethods } from "../../services/checkout"
import { setTransportOption } from "@/services/cart"

export default {
  name: "CartTransportMethod",
  components: { FormElement },
  props: {
    value: {
      type: Number,
      required: false,
      default: null,
    },
    countryid: {
      type: String,
      required: false,
      default: "NL",
    },
  },
  data() {
    return {
      transportMethod: null,
      formElement: {
        name: "transportMethods",
        label: this.$t("deliveryMethod"),
        type: "select",
        selectLabel: "description",
        selectValue: "transportID",
        options: [],
        value: "",
        disabled: false,
        placeholder: this.$t("selectAPaymethod2"),
        required: true,
        size: {
          md: 6,
          lg: 6,
        },
      },
    }
  },
  watch: {
    transportMethod(transportMethod) {
      this.$emit("input", transportMethod)
      this.setTransportOption({ transportID: transportMethod })
    },
    countryid() {
      this.getTransportMethods()
    },
  },
  created() {
    this.formElement.value = this.value
    this.getTransportMethods()
  },
  methods: {
    async setTransportOption({ transportID }) {
      await setTransportOption({
        transportID,
        countryID: this.countryid,
      })
      this.$store.dispatch("updateCart")
    },

    async getTransportMethods() {
      const result = await getTransportMethods({ countryID: this.countryid })
      this.formElement.options = result
      this.formElement = { ...this.formElement }
    },
  },
}
</script>

<style scoped></style>
